import { Typography } from "@mui/material";
import React, { Component } from "react";
import Utils from "../../common/Utils";
import Tooltip from "../Tooltip";

export default class DateLabel extends Component<any, any> {
  static defaultProps = {
    dateFormat: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    tooltipDateFormat: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  };

  render() {
    const { date, className, dateFormat, tooltipDateFormat } = this.props;

    return (
      <Tooltip title={Utils.formatDate(date, tooltipDateFormat)}>
        <Typography
          className={className}
          sx={{ display: "inline" }}
          component="span"
          variant="body2"
          fontFamily={"Inter"}
        >
          {Utils.formatDate(this.props.date, dateFormat)}
        </Typography>
      </Tooltip>
    );
  }
}
